import { useQuery } from "@tanstack/react-query";

import { authGetUser } from "@/api_client";
import { authUserQueryKey } from "@/hooks/api/auth/authUserQueryKey";

export const useUser = (enabled: boolean = true) => {
  return useQuery({
    enabled,
    queryKey: authUserQueryKey,
    queryFn: async () => (await authGetUser()).data,
  });
};
